import img1 from '/static/img/home/popularProducts/img1.jpg'
import img2 from '/static/img/home/popularProducts/img2.jpg'
import img3 from '/static/img/home/popularProducts/img3.jpg'
import img4 from '/static/img/home/popularProducts/img4.jpg'
import img5 from '/static/img/home/popularProducts/img5.jpg'
const travelList = [
    {
        id:1,
        lable:'superhost',
        img:img1,
        group:'Private small group',
        title:'Aba Secrets',
        desc:'The Minshan Mountains stretch to unfold Aba\'s panorama. Snow-capped peaks reach for cloud wisps, grasslands spread like brocade linking nomad tents, lakes mirror the sky\'s blue like mirrors, and prayer flags whisper devotion in the wind. Where nature meets faith, savor the pure grace of Western Sichuan quietly.',
        time:'3'
    },
    {
        id:2,
        lable:'superhost',
        img:img5,
        group:'Private small group',
        title:'Ganzi Sacred Realm',
        desc:'Deep in the Hengduan Mountains lies Ganzi\'s sacred realm. Snow mountains stand like Buddhas in the sky, meadows stretch like blankets to the horizon, lakes nestle in valleys with turquoise hues, and prayer flags spread over mountains chanting sacred sounds. Where heaven and earth dance with faith, savor the holy grace of Western Sichuan quietly.',
        time:'5-7'
    },
    {
        id:3,
        lable:'superhost',
        img:img2,
        group:'Private small group',
        title:'Chengdu Leisure',
        desc:'The fertile land of Tianfu nurtures Chengdu\'s leisure charm. Pandas bring cuteness at the base, tea fragrance lingers in Kuanzhai Alleys, Dujiangyan irrigates for millennia, and Sanxingdui unlocks ancient Shu mysteries. Where vibes meet civilization, savor Sichuan\'s grace slowly.',
        time:'3-7'
    },
    {
        id:4,
        lable:'superhost',
        img:img4,
        group:'Private small group',
        title:'Chongqing Layers',
        desc:'Two rivers cut through the city, forging Chongqing\'s layered charm. Stilted buildings climb mountains in layers, light rail through buildings paints wonders, Hongya Cave glows like a starry river at night, and old hotpot simmers the city\'s spirit. Where landscapes meet vibes, savor the fiery grace of the mountain city.',
        time:'3-7'
    },
    {
        id:5,
        lable:'superhost',
        img:img3,
        group:'Private small group',
        title:'Guangzhou Vibes',
        desc:'The Pearl River flows through the city, nurturing Guangzhou\'s lively vibes. Arcaded streets hold local life, morning tea dim sum overflows with fragrance, Cantonese opera carries ancient charm, and Canton Tower overlooks new chapters. Tradition dances with trends, savoring Yangcheng\'s grace gently.',
        time:'3-5'
    },
]

export default {
    travelList
}